import { render, staticRenderFns } from "./contract-text.component.vue?vue&type=template&id=6dc849d6"
import script from "./contract-text.component.vue?vue&type=script&lang=ts"
export * from "./contract-text.component.vue?vue&type=script&lang=ts"
import style0 from "./contract-text.component.vue?vue&type=style&index=0&id=6dc849d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports